import gql from 'graphql-tag';

const SELLER_FRAGMENT = gql`
  fragment SellerFragment on Seller {
    title
    description
  }
`;

export default SELLER_FRAGMENT;
